/**
 * Constants for PPT Canvas
 */
/** width in abstract PowerPoint units */
export const CANVAS_WIDTH_UNITS: number = 1440 // Abstract units used in ReportingCanvas state
/** height in abstract PowerPoint units */
export const CANVAS_HEIGHT_UNITS: number = 810
/** slide width in inches */
export const POWERPOINT_WIDTH_INCHES: number = 10 // Standard 16:9 width
/** slide height in inches */
export const POWERPOINT_HEIGHT_INCHES: number = 5.625 // Standard 16:9 height
/** size in abstract PowerPoint units */
export const GRID_SIZE_UNITS: number = 30
